// removed by extract-text-webpack-plugin
module.exports = {"titleContainer":"pwh97bsvn8je7keme6qtyvdm4trvuumvtaxp6esn26h8yfycaqv1d4z43pxav7fez4bfamc2eas8bf336kkdya1jq56e96ad97rdkr-pageTitle-module-titleContainer","title":"_3qr56pfkxz7qs7dnyw9nq4wr7hwatcrzdwtpfg22mvnt1v5rnyfqc6p8rszqbr3h4azxqwqdv64t7czme2c1b14xgtzq1mtjzu7f7wu-pageTitle-module-title"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/styles/pageTitle.module.scss
// module id = 330
// module chunks = 0